/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, $Sprite} from '@gongxigames/framework/core/fragments/BuilderY';
import {$UIText} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/UIText';
import {LabelShowManager} from './LabelShowManager';
import {Point, Container as PixiContainer} from 'pixi.js';
import {METER_TEXT_FIELD_ID, WinMeterManager} from './WinMeterManager';
import {RichText, Store} from '@gongxigames/framework/core';
import {TICKER_TEXT_FIELD_ID} from '@gongxigames/framework/slotV2/ui/ui-koala/modules/UIMainScreen/components/WinArea/TickerManager';
import {uiTickerStore} from '@gongxigames/framework/slotV2/ui/services/UITicker/uiTickerStore';

export const $WinAreaPortrait: FC = () => {
    const bg = <$Sprite
        texture='custom_message_field'
        anchor={0.5}
    />;

    const winMeter = <$UIText
        localeID='winPortrait'
        name={METER_TEXT_FIELD_ID}
        stylePreset='WIN_VALUE_LABEL_PORTRAIT'
    />;

    const style = Store.computed(() => {
        return {fill: uiTickerStore.color.value};
    });

    const textField = <$UIText
        name={TICKER_TEXT_FIELD_ID}
        stylePreset='TICKER_VALUE_PORTRAIT'
        style={style}
        text={uiTickerStore.text}
    />;

    const textFields = [{
        id: METER_TEXT_FIELD_ID,
        container: winMeter as PixiContainer,
        backPosition: new Point(0, -18),
    },
    {
        id: TICKER_TEXT_FIELD_ID,
        container: textField as PixiContainer,
        backPosition: new Point(0, 24),
    }];

    const labelShowManager = new LabelShowManager(new Point(), textFields, bg as PixiContainer);

    // do not remove
    new WinMeterManager(labelShowManager, winMeter as RichText);

    return <$Container
        name='win_area_portrait'
        responsive={{
            box: {x: '50%', y: '100%'},
            translate: {y : '-684px'}
        }}
    >
        {bg}
        {winMeter}
        {textField}
    </$Container>;
};